import axios from "axios";

export const fetchOffersForVenue = async venue => {
  try {
    const response = await axios.get(
      window.API + "/venue/" + venue + "/offers"
    );
    return { result: response.data };
  } catch (error) {
    return { error };
  }
};
